const singletonId = Symbol();
const singletonEnforcer = Symbol();

class EquipModel {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) throw new Error('EquipModel can not use construct. use getInstance method');

    const _ = this;

    _.isLogin = false;

    _.DEVICE_TYPE = '';

    _.CNB_HEIGHT = 107;

    _.DEFAULT_SERVER_ID = 1;

    // 2019.11  90lv 미만 캐릭터의 스탯 한도 45 -> 50
    // 2021.12  100lv 이상 50 -> 55
    _.STAT_MAX = 50;

    // when level >= 90, stat max change 50 from 45.
    // 2019.11 90lv 이상 캐릭터의 스탯 한도 50 -> 55
    _.LEVEL_CHANGE_STAT_MAX = 90;
    _.CHANGED_STAT_MAX = 55;
    // 2021.12 100레벨이 되면 60
    _.STAT_MAX_BY_LEVEL = [{level: 50, max: 50 }, {level: 90, max: 55 }, {level: 100, max: 60 }];


    // equip
    _.USER_EQUIP_NUM_LIMIT = 6;

    _.MY_CHARACTER_STAT_PER_PAGE_NUM = 6;

    _.MY_CHARACTER_STAT_PAGE_BTN_NUM = 5;

    _.SWORD_STYLE = {
      ONEHAND: '한손',
      TWOHAND: '양손'
    };

    _.SWORD_TYPE = {
      SPEAR: '창',
      ONEHAND_SWORD: '한손검',
      BOW: '활',
      BLUNT: '둔기',
      ARROW: '화살'
    };

    _.PRICE_UINTS = ['', '만', '억'];

    _.SLOT_NAMES = ['sword_0', 'sword_1', 'headpiece_0', 't_shirt_0', 'armor_0', 'cloak_0', 'gloves_0', 'gaiter_0', 'shield_0', 'guard_0', 'shoulder_0', 'emblem_0', 'necklace_0', 'pendant_0', 'belt_0', 'ring_0', 'ring_1', 'ring_2', 'ring_3', 'earring_0', 'earring_1', 'boots_0', 'relic_0', 'crest_0']; //201908
  }

  static getInstance() {
    if (!this[singletonId]) this[singletonId] = new EquipModel(singletonEnforcer);
    return this[singletonId];
  }
}

export default EquipModel;



// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/EquipModel.js